if (!customElements.get('baci-shipping-demo')) {
  customElements.define('baci-shipping-demo', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.cart = {total_price: Number(this.dataset.cartTotal), item_count: Number(this.dataset.cartCount), currency: this.dataset.currency};
      this.busy = false;
      this.querySelectorAll('.baci-demo__form select').forEach(select => {
        select.closest('article').querySelector('[data-price]').textContent = this.money(Number(select.selectedOptions[0].dataset.price));
      });
      this.querySelector('[data-demo-input]').addEventListener('input', () => this.render(), {signal: this.controller.signal});
      this.querySelector('[data-simulation]').addEventListener('change', () => this.render(), {signal: this.controller.signal});
      this.addEventListener('submit', event => this.add(event), {signal: this.controller.signal});
      this.addEventListener('change', event => {
        if (event.target.matches('select[name="id"]')) {
          const price = Number(event.target.selectedOptions[0].dataset.price);
          event.target.closest('article').querySelector('[data-price]').textContent = this.money(price);
        }
      }, {signal: this.controller.signal});
      document.addEventListener('cart:update', event => {
        if (typeof event.detail?.total_price === 'number') {
          this.cart = event.detail;
          this.render();
        } else this.refresh().catch(() => {});
      }, {signal: this.controller.signal});
      document.addEventListener('ajaxProduct:added', () => this.refresh().catch(() => {}), {signal: this.controller.signal});
      window.addEventListener('pageshow', () => this.refresh().catch(() => {}), {signal: this.controller.signal});
      this.render();
      this.refresh().catch(() => {});
    }
    disconnectedCallback() { this.controller?.abort(); }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-CA', {style: 'currency', currency: this.cart.currency || this.dataset.currency}).format(cents / 100);
    }
    render() {
      const simulated = this.querySelector('[data-simulation]').checked;
      const total = simulated ? Math.max(0, Number(this.querySelector('[data-demo-input]').value) || 0) * 100 : this.cart.total_price;
      const threshold = Math.max(1, Number(this.dataset.threshold) || 7500);
      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, Math.max(0, total / threshold * 100));
      const heading = this.querySelector('[data-heading]');
      const eligible = (this.cart.currency || this.dataset.currency) === 'CAD' && this.dataset.country === 'CA';
      if (!eligible) heading.textContent = this.strings.outside;
      else if (remaining === 0) heading.textContent = this.strings.success;
      else {
        heading.replaceChildren(document.createTextNode(this.strings.heading + ' '));
        const amount = document.createElement('strong');
        amount.textContent = this.money(remaining);
        heading.append(amount, document.createTextNode(' ' + this.strings.headingEnd));
      }
      this.querySelector('[data-fill]').style.width = progress + '%';
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.floor(progress));
      this.querySelector('[data-subtotal]').textContent = this.money(total);
      this.querySelectorAll('[data-threshold]').forEach(el => {el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-CA', {style:'currency',currency:'CAD',maximumFractionDigits:0}).format(threshold / 100);});
      this.querySelector('[data-real-total]').textContent = this.money(this.cart.total_price);
      this.querySelector('[data-count]').textContent = '(' + this.cart.item_count + ')';
      this.querySelectorAll('[name="checkout"]').forEach(button => {
        button.disabled = this.cart.item_count === 0 || this.busy;
      });
      this.querySelector('[data-note]').textContent = simulated ? this.strings.demoNote : this.strings.realNote;
    }
    async refresh() {
      const response = await fetch(this.dataset.root + 'cart.js', {signal: this.controller.signal});
      if (!response.ok) throw new Error(this.strings.error);
      this.cart = await response.json();
      this.render();
      return this.cart;
    }
    async add(event) {
      const form = event.target.closest('.baci-demo__form');
      if (!form) return;
      event.preventDefault();
      if (this.busy || !form.reportValidity()) return;
      this.busy = true;
      const buttons = [...this.querySelectorAll('.baci-demo__form button')];
      const states = buttons.map(button => button.disabled);
      buttons.forEach(button => {button.disabled = true;});
      const status = this.querySelector('[data-status]');
      status.textContent = this.strings.busy;
      this.render();
      let added = false;
      try {
        const data = new FormData(form);
        const response = await fetch(this.dataset.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(data.get('id')),quantity:Number(data.get('quantity'))}]}),signal:this.controller.signal});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.strings.error);
        added = true;
        this.querySelector('[data-simulation]').checked = false;
        const cart = await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:update', {detail:cart}));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:cart}));
        status.textContent = this.strings.added;
      } catch(error) {
        if (error.name !== 'AbortError') status.textContent = added ? this.strings.added + ' ' + this.strings.error : error.message || this.strings.error;
      } finally {
        this.busy = false;
        buttons.forEach((button, index) => {button.disabled = states[index];});
        this.render();
      }
    }
  });
}
